import BaseService from './base.service'

const XLSX_MIMETYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const ZIP_MIMETYPE = 'application/zip';

export default class ThalamusService extends BaseService {
    /**
     * Estado (enviado / no enviado) de los archivos de ventas y clientes para cada día hábil del período.
     */
    getArchivos(desde, hasta, fnSuccess, fnError) {
        return this.getApi().get(`/thalamus/archivos?desde=${desde}&hasta=${hasta}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al obtener el estado de los archivos de Thalamus')));
    }

    /**
     * Descarga varios archivos juntos: 'zip' con los originales o 'excel' unificando todo en un
     * único xlsx con una hoja de ventas y otra de clientes.
     */
    descargarArchivos(formato, rutas, fnSuccess, fnError) {
        return this.getApi()({
            url: '/thalamus/descargas',
            method: 'post',
            data: {
                formato: formato,
                archivos: rutas
            },
            responseType: 'blob'
        })
            .then(response => {
                const file = new Blob([response.data], {type: formato === 'zip' ? ZIP_MIMETYPE : XLSX_MIMETYPE});
                fnSuccess(file, response.headers['n-filename']);
            })
            .catch(async error => {
                // Al pedir un blob el cuerpo del error también viene como Blob, hay que leerlo para
                // poder mostrar el mensaje que devuelve el backend.
                if (error.response && error.response.data instanceof Blob)
                    try {
                        error.response.data = JSON.parse(await error.response.data.text());
                    } catch (e) {
                    }

                fnError(this.getMessageFromError(error, 'Error al descargar los archivos de Thalamus'));
            });
    }
}
